import { useEffect, useRef } from 'react';
import { useSipWebsocket } from 'app/protocol/SipWebsocketProvider';
import { format } from 'date-fns';
import Command from 'app/protocol/Command';
import CsvData from './CsvData';

function CsvDataParser(props) {
	const { message } = useSipWebsocket();
	const csvDataRef = useRef(new CsvData());

	useEffect(() => {
		if (props.running) {
			csvDataRef.current = new CsvData();
		} else if (props.device) {
			if (csvDataRef.current.data.length > 0) {
				const blobData = new Blob([csvDataRef.current.toString()], { type: 'text/csv' });
				const _csvUrl = window.URL.createObjectURL(blobData);
				props.handleCsvName(`streaming_${format(new Date(), 'yyyy_MM_dd_HH_mm_ss')}.csv`);
				props.handleCsvUrl(_csvUrl);
			} else {
				props.handleCsvName(null);
				props.handleCsvUrl(null);
			}
		}
	}, [props.running]);

	useEffect(() => {
		if (props.running && message instanceof Command) {
			if (message.command === Command.STREAMING_DATA_PACKET) {
				addToCsv(message.sensorDataBuffer);
			} else if (message.command === Command.STREAMING_TYPE_PACKET) {
				initHeader(message.sensorTypes);
			}
		}
	}, [message]);

	const initHeader = sensorTypes => {
		const csvLabels = [];
		sensorTypes.forEach(sensorType => {
			sensorType.sensorValues.forEach(sensorValue => {
				csvLabels.push(findSensorValueLabel(sensorType.typeId, sensorValue.typeId));
			});
		});
		csvDataRef.current.appendString(`${csvLabels.join(',')}\r\n`);
	};

	const addToCsv = dataBuffer => {
		dataBuffer.forEach(currentData => {
			const values = currentData.map(d => d.data);
			csvDataRef.current.appendString(`${values.join(',')}\r\n`);
		});
	};

	const findSensorValueLabel = (sensorId, valueId) => {
		const sensor = props.device.deviceType.sensorTypeList.find(s => s.externalId === sensorId);
		if (sensor) {
			const value = sensor.valueList.find(v => v.externalId === valueId);
			if (value) return `"${sensor.modelId}.${value.name}"`;
		}
		return null;
	};

	return <></>;
}

export default CsvDataParser;
